import CustomText from "@components/CustomText";
import color from "@constants/color";
import Cross from "@assets/svg/CrossRed";
import {
  Modal,
  TouchableNativeFeedback,
  View,
  StyleSheet,
  TouchableWithoutFeedback,
} from "react-native";
import React from "react";

const InfoTooltipModal = ({ text = "", visible, setVisible }) => {
  return (
    <>
      <Modal animationType="fade" transparent={true} visible={visible}>
        <TouchableWithoutFeedback onPress={() => setVisible(false)}>
          <View style={styles.modal} />
        </TouchableWithoutFeedback>
        <View style={styles.modalContainer}>
          <View style={styles.headerContainer}>
            <TouchableNativeFeedback
              testID="Cross"
              onPress={() => setVisible(false)}
            >
              <Cross
                width={24}
                height={24}
                bgColor="rgba(0,0,0,0.1)"
                color="black"
              />
            </TouchableNativeFeedback>
          </View>
          <CustomText key={text} variant="body_text_3" style={styles.textColor}>
            {text}
          </CustomText>
        </View>
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  modal: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  modalContainer: {
    top: 100,
    backgroundColor: color.white,
    borderRadius: 16,
    padding: 8,
    margin: 16,
    position: "absolute",
  },
  headerContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    padding: 2,
  },
  textColor: { color: "rgba(0, 0, 0, 0.86)", padding: 16, paddingTop: 0 },
});

export default InfoTooltipModal;
